import { render, staticRenderFns } from "./DecoEntryForMod.vue?vue&type=template&id=395ef1e4&"
import script from "./DecoEntryForMod.vue?vue&type=script&lang=ts&"
export * from "./DecoEntryForMod.vue?vue&type=script&lang=ts&"
import style0 from "./DecoEntryForMod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports